import Vue from 'vue'
import VueRouter from 'vue-router'
import pla from '@/router/pla'
import pro from '@/router/pro'
import fat from '@/router/fat'
import store from '@/router/store'



Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'login',
    component: ()=>import("@/views/login.vue"),
	meta:{
		title:"店开供应链系统",
		requiresAuth:false
	}
  },
  {
    path: '/register',
    name: 'register',
    component: ()=>import("@/views/register.vue"),
	meta:{
		title:"注册供应商",
		requiresAuth:false
	}
  },
  {
    path: '/forget',
    name: 'forget',
    component: ()=>import("@/views/forget.vue"),
	meta:{
		title:"找回密码",
		requiresAuth:false
	}
  },
  {
    path: '/home',
    name: 'home',
    component: ()=>import("@/views/main.vue"),
	meta:{
		title:"平台管理后台",
		requiresAuth:false
	},  
	// children:[

	// ]
  },  

	pla,
	pro,
	fat,
	store
]

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
})

// 在全局前置守卫中设置页面标题
router.beforeEach((to, from, next) => {
	
	if(to.meta.title){
		document.title = "店开甄选" + "_" + to.meta.title;
	}else{
		document.title = "店开甄选";
	}	
    next();
});
export default router
